import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Check, Circle, ChevronRight, ExternalLink, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

/** Un passo del promemoria: istruzioni, stato (auto o manuale) e scorciatoie. */
export const PassoCard = ({ passo, numero, fatto, dettaglio, spunta, onSpunta, salvando, isAdmin }) => {
  const navigate = useNavigate();
  const auto = passo.tipo === 'auto';

  return (
    <Card
      className={cn('transition-colors', fatto ? 'border-emerald-500/40 bg-emerald-500/5' : 'border-border')}
      data-testid={`passo-${passo.chiave}`}
    >
      <CardContent className="p-4 space-y-2.5">
        <div className="flex items-start gap-3">
          <div
            className={cn(
              'w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-xs font-bold',
              fatto ? 'bg-emerald-600 text-white' : 'bg-secondary text-muted-foreground',
            )}
          >
            {fatto ? <Check className="w-4 h-4" /> : numero}
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-semibold leading-tight">{passo.titolo}</p>
            <p className="text-[11px] uppercase tracking-wide text-muted-foreground mt-0.5">{passo.fonte}</p>
          </div>
          <Badge
            variant="outline"
            className={cn('shrink-0 text-[10px]', fatto ? 'border-emerald-600 text-emerald-700' : 'text-muted-foreground')}
            data-testid={`passo-stato-${passo.chiave}`}
          >
            {fatto ? 'Fatto' : 'Da fare'}
          </Badge>
        </div>

        <div className="text-xs text-muted-foreground space-y-1 pl-10">
          {passo.istruzioni.map((r) => <p key={r}>{r}</p>)}
        </div>

        {dettaglio && (
          <div className="pl-10 text-xs" data-testid={`passo-dettaglio-${passo.chiave}`}>
            {dettaglio}
          </div>
        )}

        <div className="pl-10 flex flex-wrap items-center gap-2">
          {passo.link?.path && (
            <Button
              variant="outline"
              size="sm"
              className="h-8 text-xs"
              onClick={() => navigate(passo.link.path)}
              data-testid={`passo-link-${passo.chiave}`}
            >
              {passo.link.label} <ChevronRight className="w-3.5 h-3.5 ml-1" />
            </Button>
          )}
          {passo.link?.url && (
            <Button
              variant="outline"
              size="sm"
              className="h-8 text-xs"
              asChild
              data-testid={`passo-link-${passo.chiave}`}
            >
              <a href={passo.link.url} target="_blank" rel="noreferrer">
                {passo.link.label} <ExternalLink className="w-3.5 h-3.5 ml-1" />
              </a>
            </Button>
          )}
          {spunta}
        </div>

        {auto ? (
          <p className="pl-10 text-[11px] text-muted-foreground">
            La spunta si accende da sola quando i dati del mese sono in archivio.
          </p>
        ) : (
          isAdmin && (
            <div className="pl-10">
              <Button
                variant={fatto ? 'ghost' : 'secondary'}
                size="sm"
                className="h-8 text-xs"
                onClick={() => onSpunta(!fatto)}
                disabled={salvando}
                data-testid={`passo-spunta-${passo.chiave}`}
              >
                {salvando
                  ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />
                  : fatto
                    ? <Check className="w-3.5 h-3.5 mr-1.5 text-emerald-600" />
                    : <Circle className="w-3.5 h-3.5 mr-1.5" />}
                {fatto ? 'Annulla spunta' : passo.spunta}
              </Button>
            </div>
          )
        )}
      </CardContent>
    </Card>
  );
};

export default PassoCard;
